import React from 'react';

export const EmptyPage = () => (
    <div>
    </div>
);


// WEBPACK FOOTER //
// src/views/empty/index.jsx